"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startDateGuardManifest = void 0;
const generated_1 = require("../generated");
const guards_1 = require("../guards");
/**
 * The startDate guard determines the start date of the mint.
 * Before this date, minting is not allowed.
 */
exports.startDateGuardManifest = {
    name: 'startDate',
    serializer: generated_1.getStartDateSerializer,
    mintParser: guards_1.noopParser,
    routeParser: guards_1.noopParser,
};
//# sourceMappingURL=startDate.js.map